import { scssModules } from './scss-modules'

/**
 *
 *
 *
 */
export function importStyles(stylesScss: string): Promise<string> {
  return scssModules[`../scss/${stylesScss}`]()
}
